<p [innerHTML]="'DIPRSRegistration.phoneNumber.help.modal.text' | authTranslate">
</p>

<div class="row td-toolbar">
  <div class="col-sm-6 mx-auto">
    <button type="button" class="btn btn-block td-btn-primary-light" (click)="closeBtnClick()">
      {{ 'DIPRSRegistration.phoneNumber.help.modal.close' | translate }}
    </button>
  </div>
</div>
